import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'CURRICULUM_ADD_SHEET_GET',
  GET_SUCCESS: 'CURRICULUM_ADD_SHEET_GET_SUCCESS',
  GET_FAILURE: 'CURRICULUM_ADD_SHEET_GET_FAILURE',
  POST: 'CURRICULUM_ADD_SHEET_POST',
  POST_SUCCESS: 'CURRICULUM_ADD_SHEET_POST_SUCCESS',
  POST_FAILURE: 'CURRICULUM_ADD_SHEET_POST_FAILURE',
  PATCH: 'CURRICULUM_ADD_SHEET_PATCH',
  PATCH_SUCCESS: 'CURRICULUM_ADD_SHEET_PATCH_SUCCESS',
  PATCH_FAILURE: 'CURRICULUM_ADD_SHEET_PATCH_FAILURE',
};

export const get = actions.get(nodeId => `${BASE_V2_URL}/practice-sheets/${nodeId}/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const post = actions.post(() => `${BASE_V2_URL}/practice-sheets/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(
  nodeId => `${BASE_V2_URL}/practice-sheets/${nodeId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
